import { ImageType } from '@/@types/schemas/images'

function getInitials(name: string): string {
  const parts = name.split(' ')

  if (parts.length === 1) {
    return parts[0][0].toUpperCase().concat(parts[0][1].toUpperCase())
  }

  return parts
    .filter(Boolean)
    .map((n) => n[0])
    .slice(0, 2)
    .join('')
    .toUpperCase()
}

export function randomPattern(type: ImageType, name: string) {
  const initials = getInitials(name)

  if (type === 'card') {
    return (
      <div className="flex h-full w-full items-center justify-center bg-foreground/5 text-xl font-bold text-foreground">
        <div className="flex h-16 w-16 items-center justify-center rounded-full bg-background text-foreground">
          {initials}
        </div>
      </div>
    )
  }

  return (
    <div className="flex h-full w-full items-center justify-center bg-muted font-bold text-muted-foreground">
      {initials}
    </div>
  )
}
